import { Box, Grid, List, ListItem, Typography } from '@mui/material'
import Header from 'components/Header'
import { useLocation } from 'react-router-dom'
import { getPickingBackColor } from 'utils'

const DailyOrderDetail = () => {
  const location = useLocation()
  const { order } = location.state || {}
  return (
    <Box>
      <Header />
      <List sx={{ maxWidth: '80%', margin: '50px auto' }}>
        {order.orderItems.map((item: any) => (
          <ListItem
            key={item._id}
            sx={{
              display: 'block',
              backgroundColor: getPickingBackColor(item),
              marginBottom: '10px',
              borderRadius: '8px',
              padding: '10px'
            }}
          >
            <Grid container justifyContent='space-between' alignItems='center'>
              <Grid>
                <Typography>{item.name}</Typography>
                <Typography>Note: {item.note}</Typography>
                <Typography sx={{ fontWeight: 600 }}>
                  Bin: {item.bin}
                </Typography>
              </Grid>
              <Grid sx={{ textAlign: 'right' }}>
                <Typography>Quantity: {item.quantity}</Typography>
                <Typography>
                  Quantity Remaining: {item.quantityRemaining}
                </Typography>
              </Grid>
            </Grid>
          </ListItem>
        ))}
      </List>
    </Box>
  )
}

export default DailyOrderDetail
